import { render, staticRenderFns } from "./CostComposeDialog.vue?vue&type=template&id=b523f9c0&scoped=true&"
import script from "./CostComposeDialog.vue?vue&type=script&lang=js&"
export * from "./CostComposeDialog.vue?vue&type=script&lang=js&"
import style0 from "./CostComposeDialog.vue?vue&type=style&index=0&id=b523f9c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b523f9c0",
  null
  
)

export default component.exports